/* Theme 109: URL-authoritative exact-tag collection routing. No product fitment is inferred here. */
(function () {
  'use strict';
  var VERSION = '116-25sep2026-catalogue-reconciliation';
  var SORT_KEY = 'bbt_sort_preference_v1';
  var VEHICLE_KEY = 'bbt_selected_vehicle_v1';
  var DEFAULT_SORT = 'price-ascending';
  var SORTS = ['price-ascending','price-descending','title-ascending','title-descending','created-ascending','created-descending','best-selling','manual'];
  var SYSTEMS = [
    ['engine-management','Engine Management'],['wiring-sensors-displays','Wiring, Sensors & Displays'],
    ['turbo-forced-induction','Turbo & Forced Induction'],['intercooler','Intercooler'],['fuel-system','Fuel System'],
    ['intake','Intake'],['exhaust','Exhaust'],['engine-parts','Engine Parts'],['ignition','Ignition'],['clutch','Clutch'],
    ['transmission-driveline','Transmission & Driveline'],['cooling','Cooling'],['suspension-brakes','Suspension & Brakes'],['tools-accessories','Tools & Accessories'],
    ['service-maintenance','Service & Maintenance'],['exterior-aero','Exterior & Aero']
  ].map(function (s) { return {key:s[0], label:s[1], collection:'bbt-nav-universal-'+s[0], tag:'bbt-cat-'+s[0]}; });
  var LEGACY = {
    'bt-cat-product-engine-management':'engine-management','bt-cat-product-haltech-ecu':'engine-management',
    'bt-cat-product-haltech-wiring':'wiring-sensors-displays','bt-cat-product-sensors':'wiring-sensors-displays','bt-cat-product-dash-display':'wiring-sensors-displays',
    'bbt-cat-intercoolers':'intercooler','bbt-cat-intercooler-kits':'intercooler','bbt-cat-intercooler-piping-kits':'intercooler',
    'bt-cat-product-fuel-system':'fuel-system','bt-cat-product-engine-conversion':'engine-parts','bt-cat-product-ignition':'ignition',
    'bbt-cat-driveline':'transmission-driveline','bbt-cat-oil-management':'cooling','bbt-cat-suspension':'suspension-brakes',
    'bbt-cat-brakes':'suspension-brakes','bt-cat-product-tools-accessories':'tools-accessories',
    'bt-cat-service':'service-maintenance','bt-cat-exterior-aero':'exterior-aero','bt-cat-aero':'exterior-aero'
  };
  SYSTEMS.forEach(function (s) { LEGACY[s.tag] = s.key; });
  var index = null;
  function url() { return new URL(window.location.href); }
  function isSearch(path) { return /\/search\/?$/.test(path); }
  function isCatalogue(u) { return /\/collections\//.test(u.pathname) || (isSearch(u.pathname) && /^tag:/i.test((u.searchParams.get('q') || '').trim())); }
  function getStoredSort() { try { return sessionStorage.getItem(SORT_KEY) || ''; } catch (e) { return ''; } }
  function saveSort(sort) { if (SORTS.indexOf(sort)<0) return; try { sessionStorage.setItem(SORT_KEY, sort); } catch (e) {} }
  function preferredSort() {
    var u = url(), current = u.searchParams.get('sort_by') || '';
    // An explicit valid URL sort wins, including Low -> High. A saved choice cannot override a shared URL.
    if (isCatalogue(u) && SORTS.indexOf(current)>=0) return current;
    var stored = getStoredSort();
    return SORTS.indexOf(stored)>=0 ? stored : DEFAULT_SORT;
  }
  function localPath(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root !== '/' && /^\/(search|collections)(\/|\?|$)/.test(path)) return root.replace(/\/$/,'') + path;
    return path;
  }
  function preservePreview(u) {
    ['preview_theme_id','_ab','_fd','pb'].forEach(function (key) {
      if (!u.searchParams.has(key) && url().searchParams.has(key)) u.searchParams.set(key, url().searchParams.get(key));
    });
    return u;
  }
  function destination(raw) {
    var u = new URL(localPath(raw), window.location.origin);
    if (u.origin !== window.location.origin) return raw;
    if (isSearch(u.pathname)) {
      var exact = searchURLContext(u);
      if (exact) u = exactCollectionURL(u, exact);
    }
    if (isCatalogue(u)) u.searchParams.set('sort_by', preferredSort());
    var nativeParts=u.pathname.match(/\/collections\/[^/]+\/([^/]+)\/?$/);
    if (nativeParts) {
      var nativeRoute;
      try { nativeRoute=decodeURIComponent(nativeParts[1]); } catch (e) { nativeRoute=''; }
      if (stateForRoute(nativeRoute)) u.searchParams.set('bbt_route',nativeRoute);
    }
    if (isSearch(u.pathname) && /^tag:/i.test(u.searchParams.get('q') || '')) {
      u.searchParams.set('type','product'); u.searchParams.set('options[prefix]','none');
    }
    preservePreview(u);
    return u.pathname + u.search + u.hash;
  }
  function buildIndex() {
    var source = window.BBT_VEHICLE_DATA;
    if (!source || source.version !== VERSION) return null;
    if (index) return index;
    index = Object.create(null);
    Object.keys(source.data).forEach(function (make) {
      Object.keys(source.data[make]).forEach(function (model) {
        Object.keys(source.data[make][model]).forEach(function (generation) {
          source.data[make][model][generation].forEach(function (item) {
            if (!item.routeTag) return;
            index[item.routeTag] = {make:make, model:model, generation:generation, engine:item.label, family:item.family,
              routeType:item.routeType, engineTag:item.engineTag || '', routeTag:item.routeTag,
              systems:item.systems.slice(), systemCounts:Object.assign({},item.systemCounts), productCount:item.productCount,
              catalogueVersion:VERSION, url:item.url};
          });
        });
      });
    });
    return index;
  }
  function stateForRoute(tag) {
    var data=buildIndex(), state=data && data[tag];
    return state ? Object.assign({},state,{systems:state.systems.slice(),systemCounts:Object.assign({},state.systemCounts)}) : null;
  }
  function system(key) { return SYSTEMS.find(function (s) { return s.key===key; }) || null; }
  function queryContext(q) {
    q=String(q || '').trim();
    q=q.replace(/tag:(?:"([A-Za-z0-9_-]+)"|'([A-Za-z0-9_-]+)')/ig,function (_,doubleQuoted,singleQuoted) { return 'tag:'+(doubleQuoted || singleQuoted); });
    var strict=q.match(/^tag:bt-fit-rs-([A-Za-z0-9_-]+)-(engine-management|wiring-sensors-displays|turbo-forced-induction|intercooler|fuel-system|intake|exhaust|engine-parts|ignition|clutch|transmission-driveline|cooling|suspension-brakes|tools-accessories|service-maintenance|exterior-aero)$/i);
    if (strict) {
      var strictState=stateForRoute('bt-fit-route-'+strict[1].toLowerCase());
      return strictState ? {state:strictState,system:strict[2].toLowerCase(),legacy:true} : null;
    }
    var tokens=q.match(/tag:[A-Za-z0-9_-]+/ig) || [];
    // Do not simplify OR expressions, exclusions, multiple vehicles or free-text searches.
    var remainder=q.replace(/tag:[A-Za-z0-9_-]+/ig,'').replace(/\bAND\b/g,'').replace(/[\s()]/g,'');
    if (remainder || !tokens.length || /\bOR\b/i.test(q)) return null;
    var routes=[], keys=[];
    for (var i=0;i<tokens.length;i++) {
      var tag=tokens[i].slice(4).toLowerCase();
      if (tag.indexOf('bt-fit-route-')===0) routes.push(tag);
      else if (LEGACY[tag]) keys.push(LEGACY[tag]);
      else return null;
    }
    if (routes.length!==1 || keys.some(function (key) { return key!==keys[0]; })) return null;
    var state=stateForRoute(routes[0]);
    return state ? {state:state,system:keys[0] || '',legacy:keys.length>0} : null;
  }
  function searchURLContext(u) {
    var result=queryContext(u.searchParams.get('q'));
    if (!result) return null;
    var param=u.searchParams.get('bbt_system') || '';
    if (param && (!system(param) || (result.system && result.system!==param))) return null;
    if (param) { result.system=param; result.legacy=true; }
    return result;
  }
  function exactCollectionURL(source, context) {
    var collection=context.system ? system(context.system).collection : 'all';
    var u=new URL(localPath('/collections/'+collection+'/'+encodeURIComponent(context.state.routeTag)),window.location.origin);
    // Keep storefront facets, pagination, customer sort and preview parameters.
    // Search-only parameters must not leak into the collection template selector.
    source.searchParams.forEach(function (value,key) {
      if (['q','type','options[prefix]','options[unavailable_products]','view','bbt_system'].indexOf(key)<0) u.searchParams.append(key,value);
    });
    u.searchParams.set('bbt_vehicle','1');
    u.searchParams.set('bbt_route',context.state.routeTag);
    if (context.system) u.searchParams.set('bbt_system',context.system);
    if (source.searchParams.get('options[unavailable_products]')==='hide' && !u.searchParams.has('filter.v.availability')) u.searchParams.set('filter.v.availability','1');
    return u;
  }
  function currentContext() {
    var u=url();
    if (isSearch(u.pathname)) return searchURLContext(u);
    var parts=u.pathname.match(/\/collections\/([^/]+)\/([^/]+)\/?$/);
    if (!parts) return null;
    var tag;
    try { tag=decodeURIComponent(parts[2]); } catch (e) { return null; }
    var collectionState=stateForRoute(tag);
    if (!collectionState) return null;
    var s=SYSTEMS.find(function (entry) { return entry.collection===parts[1]; });
    return {state:collectionState,system:s ? s.key : '',legacy:false};
  }
  function allHref(state) {
    if (!state || !stateForRoute(state.routeTag)) return '';
    return destination('/collections/all/'+encodeURIComponent(state.routeTag)+'?bbt_vehicle=1');
  }
  function systemHref(state,key) {
    var s=system(key);
    if (!s || !stateForRoute(state.routeTag)) return '';
    var u=new URL(localPath('/collections/'+s.collection+'/'+encodeURIComponent(state.routeTag)),window.location.origin);
    u.searchParams.set('bbt_vehicle','1'); u.searchParams.set('bbt_system',key);
    return destination(u.pathname+u.search);
  }
  function legacyHref() {
    var current=url();
    if (!isSearch(current.pathname)) return '';
    var context=searchURLContext(current);
    if (!context) return '';
    // Known precision queries move to exact native collection-tag filtering.
    // This avoids search-index overmatching while preserving active facets.
    var target=exactCollectionURL(current,context);
    return destination(target.pathname+target.search+target.hash);
  }
  function preserveFilterContext(parameters, current) {
    current=current || url();
    ['type','options[prefix]','options[unavailable_products]','sort_by','bbt_vehicle','bbt_system','bbt_route','preview_theme_id','_ab','_fd','pb'].forEach(function (key) {
      if (!parameters.has(key) && current.searchParams.has(key)) parameters.set(key,current.searchParams.get(key));
    });
    if (isSearch(current.pathname) && queryContext(current.searchParams.get('q'))) {
      parameters.set('type','product'); parameters.set('options[prefix]','none');
    }
    return parameters;
  }
  function guardMissingRoute() {
    var u=url(),expected=u.searchParams.get('bbt_route') || '';
    if (!/^bt-fit-route-[a-z0-9_-]+$/.test(expected) || !/\/collections\//.test(u.pathname)) return false;
    var parts=u.pathname.match(/\/collections\/[^/]+\/([^/]+)\/?$/),tags=[];
    try { tags=parts ? decodeURIComponent(parts[1]).split('+') : []; } catch (e) {}
    if (tags.indexOf(expected)>=0) return false;
    // Shopify can strip an unused tag from a collection URL. Never present the
    // resulting general collection as compatible with the requested vehicle.
    var main=document.querySelector('#MainContent');
    if (main) {
      var panel=document.createElement('section');panel.setAttribute('data-bbt-route-guard','');panel.style.padding='32px';panel.setAttribute('role','status');
      var heading=document.createElement('h1');heading.textContent='Vehicle selection unavailable';
      var copy=document.createElement('p');copy.textContent='The requested vehicle filter could not be applied. Choose your vehicle again to see compatible parts.';
      var link=document.createElement('a');link.href=((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')+'#bbt-vehicle-finder';link.textContent='Choose vehicle';
      panel.append(heading,copy,link);main.replaceChildren(panel);
    }
    return true;
  }
  function saveVehicle(state) {
    try { localStorage.setItem(VEHICLE_KEY,JSON.stringify(Object.assign({},state,{savedAt:Date.now()}))); } catch (e) {}
  }
  function label(state) { return [state.make,state.model,state.generation,state.engine].filter(Boolean).join(' \u2192 '); }
  window.BBTCatalogue={version:VERSION,systems:SYSTEMS,queryContext:queryContext,currentContext:currentContext,stateForRoute:stateForRoute,
    preferredSort:preferredSort,saveSort:saveSort,preserveFilterContext:preserveFilterContext,isCatalogue:isCatalogue,destination:destination,localPath:localPath,preservePreview:preservePreview,
    allHref:allHref,systemHref:systemHref,legacyHref:legacyHref,guardMissingRoute:guardMissingRoute,saveVehicle:saveVehicle,label:label};
})();
